import { Component, OnInit } from '@angular/core';
import { Utilservice } from '@core/services/util.service';
import { faAirFreshener } from '@fortawesome/free-solid-svg-icons';
import { VisitasService } from '@modules/visitas/services/visitas.service';
import * as moment from 'moment';
import * as toastr from "toastr";

@Component({
  selector: 'app-controle-feriado',
  templateUrl: './controle-feriado.component.html',
  styleUrls: ['./controle-feriado.component.css']
})
export class ControleFeriadoComponent implements OnInit {

  faAirFreshener = faAirFreshener;
  
  lsFeriados = [];
  idsChecks: any[] = [];

  fzsInformado = "";
  dataFeriado = "";
  nomeFeriado = "";

  isRequestingGrid: boolean = false;

  constructor(private visitService: VisitasService) { }

  ngOnInit() {

    this.consultar();

  }

  salvar(){

    if(this.fzsInformado == ""){
      toastr.error('Informe o FZS!');
      return;
    }

    if(this.dataFeriado == ""){
      toastr.error('Informe a DATA!');
      return;
    }

    
    if(this.nomeFeriado == ""){
      toastr.error('Informe o NOME DO FERIADO!');
      return;
    }

    const params: any = {
      dataSelecionada: this.dataFeriado,
      nomeFeriado: this.nomeFeriado,
      vendedorSetor: this.fzsInformado,
    }

    this.isRequestingGrid = true;

    this.visitService.saveFeriados(params).subscribe(
      resp=> {
              toastr.success("Feriado cadastrado!");

              this.consultar();
            },
      error => {
              toastr.error(error)
            }
    )
  }

  formatDate(date){
    return Utilservice.formatDate(date);
  }

  consultar(){

    this.isRequestingGrid = true;

    this.visitService.listFeriadosMunicipaisEstaduais().subscribe(
      data => {
        this.lsFeriados = data;
      },
      error => console.log(error),
      () => this.isRequestingGrid = false
    );
  }

  delete(){
    this.verificarCheckboxes();

    this.visitService.deleteFeriado(this.idsChecks).subscribe(
      data => {
        this.isRequestingGrid = false;
        toastr.success("Feriado excluido com sucesso!");
        this.consultar();
      },
      error => {
        console.log(error);
        this.isRequestingGrid = false;

        if(typeof error === 'string'){
          toastr.error(error);
        }else{
          toastr.error("Falha ao excluir o feriado!");
        }

      },
      () => console.log("Get States")
    );
  }

  verificarCheckboxes() {
    for (let item of this.lsFeriados) {
      if (item.selecionado) {
        this.idsChecks.push(item.id);
        // console.log('Checkbox marcado para o item:', item.nome);
      }
    }
  }

}
